import { Button, Grid } from "@material-ui/core";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import CircularProgress from "components/CircularProgress/CircularProgresss";
import CustomTextField from "components/UpdateUi/CustomeTextField";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CustomSelectNew from "components/UpdateUi/CustomeSelect.js";
import PropTypes from "prop-types";
import ToastModal from "views/components/ToastModal";
import { headerLabel } from "assets/properties/properties";
import { loanApplicationStatus } from "assets/properties/properties";

const LenderDetails = ({
  setNext,
  setBack,
  loanApplicationId,
  editable,
  classes,
  status,
  featureFlags,
  existingLoanData,
}) => {
  const { authToken } = useSelector((state) => state.login.authData);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [callInProgress, setCallInProgress] = useState(false);
  const [name, setName] = useState("");
  const [nameState, setNameState] = useState("");
  const [pinCode, setPinCode] = useState("");
  const [pinCodeState, setPinCodeState] = useState("");
  const [address, setAddress] = useState("");
  const [addressState, setAddressState] = useState("");
  const [lenderBranchCode, setLenderBranchCode] = useState("");
  const [lenderBranchCodeState, setLenderBranchCodeState] = useState("");
  const [lenderName, setLenderName] = useState([]);
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };

  useEffect(() => {
    getData();
  }, []);
  const getData = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.LENDER_FINDALL,
      authToken: authToken,
    });
    setCallInProgress(false);

    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      setLenderName(result.data);
      await getLenderDetails();
    }
  };

  const getLenderDetails = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.lender_details_get + loanApplicationId,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (!result.data.error_code) {
      updateData(result?.data);
    }else{
        updateData(existingLoanData?.lenderDetail);
    }
  };

  const updateData = (lenderData) => {
    setName(lenderData?.name);
    setPinCode(lenderData?.pincode);
    setAddress(lenderData?.address);
    setLenderBranchCode(lenderData?.lenderBranchCode);
  };

  const handleCancelUser = () => {
    setBack();
  };

  const handleNext = () => {
    setNext();
  };
  const isValidate = () => {
    if (name === "" || name === null || typeof name === "undefined") {
      setNameState(true);
    } else {
      setNameState(false);
    }
    if (
      lenderBranchCode === "" ||
      lenderBranchCode === null ||
      typeof lenderBranchCode === "undefined"
    ) {
      setLenderBranchCodeState(true);
    } else {
      setLenderBranchCodeState(false);
    }
    if (pinCode === "" || pinCode === null || typeof pinCode === "undefined") {
      setPinCodeState(true);
    } else {
      setPinCodeState(false);
    }
    if (address === "" || address === null || typeof address === "undefined") {
      setAddressState(true);
    } else {
      setAddressState(false);
    }
    if (
      name &&
      name !== "" &&
      lenderBranchCode &&
      lenderBranchCode !== "" &&
      pinCode &&
      pinCode !== "" &&
      address &&
      address !== ""
    ) {
      return true;
    } else {
      return false;
    }
  };
  const handleCreateUserSubmit = async (event) => {
    event.stopPropagation();
    event.preventDefault();
    if (isValidate()) {
      setCallInProgress(true);
      //NOMINEE_ADD
      const res = await apiHandler({
        url: endpoint.Lender_details_post,
        method: "POST",
        authToken: authToken,
        data: {
          loanApplicationId: loanApplicationId,
          name: name,
          pincode: pinCode,
          address: address,
          lenderBranchCode: lenderBranchCode,
        },
      });
      setCallInProgress(false);
      if (res?.data?.error_code && res?.data?.error_code === 403) {
        toastUpdate("Error", res?.data?.user_description, true);
        return;
      } else if (res?.data?.error_code) {
        toastUpdate("Error", res?.data?.user_description, true);
        return;
      } else if (res?.data?.message) {
        setNext();
      }
    }
    // }
  };

  const handleChange = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e === "" || regex.test(e)) {
      setPinCode(e);
    }
  };
  const disableFields = existingLoanData?.lenderDetail?.name ? true : !editable;
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label={headerLabel?.lender}
          subLabel={`${headerLabel.loanAppId} ${loanApplicationId}`}
          onlyLabel
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomSelectNew
              label="Lender Name*"
              value={name || ""}
              setState={setName}
              data={lenderName}
              disabled={disableFields}
              type="name"
              id="lender_name"
              error={nameState}
              setError={setNameState}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Lender Branch Code"
              required
              id="lender_branch_code"
              value={lenderBranchCode || ""}
              setState={setLenderBranchCode}
              disabled={disableFields}
              error={lenderBranchCodeState}
              setError={setLenderBranchCodeState}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Address"
              required
              id="address"
              value={address || ""}
              setState={setAddress}
              disabled={disableFields}
              error={addressState}
              setError={setAddressState}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Pin Code"
              required
              id="pinCode"
              value={pinCode || ""}
              setState={handleChange}
              maxLength="6"
              disabled={disableFields}
              error={pinCodeState}
              setError={setPinCodeState}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            style={{ textAlign: "end" }}
          >
            <Button
              size="small"
              className={classes.nextButton1}
              onClick={() => handleCancelUser()}
            >
              Back
            </Button>
            {status === loanApplicationStatus?.inProcess ||
            status === loanApplicationStatus?.aadhaar ||
            status === loanApplicationStatus?.selfiestatus ? (
              <Button
                size="small"
                disabled={callInProgress}
                className={classes.nextButton}
                onClick={(event) => handleCreateUserSubmit(event)}
              >
                Next
              </Button>
            ) : (
              <Button
                size="small"
                disabled={callInProgress}
                className={classes.nextButton}
                onClick={(event) => handleNext()}
              >
                Next
              </Button>
            )}
          </Grid>
          {callInProgress && (
            <CircularProgress callInProgress={callInProgress} />
          )}
          {toast && (
            <ToastModal
              toastMessage={toastMessage}
              toastMessageType={toastMessageType}
              toastUpdate={toastUpdate}
            />
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

LenderDetails.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
  loanApplicationId: PropTypes.object,
  loanApplicationNumber: PropTypes.object,
  editable: PropTypes.object,
};
export default LenderDetails;
